import Layout from '$merchantComponent/layout/home'
import CategoryList from './category-list';
import ProductList from './product-list';
import AddProduct from './add-product';
import editProduct from './edit-product'
export default commomImport => [{
  path: `/product-manager/`,
  name: 'ProductManager',
  component: Layout,
  meta: {
    title: 'store.itemManager', icon: 'el-icon-s-goods'
  },
  children: [
    ...CategoryList(commomImport),
    ...ProductList(commomImport),
    ...AddProduct(commomImport),
    ...editProduct(commomImport)
  ]
}];
